export default "__VITE_ASSET__6JasRdh1__"